import { render, staticRenderFns } from "./brand-top-banner.vue?vue&type=template&id=b52b8900"
import script from "./brand-top-banner.vue?vue&type=script&lang=js"
export * from "./brand-top-banner.vue?vue&type=script&lang=js"
import style0 from "./brand-top-banner.vue?vue&type=style&index=0&id=b52b8900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports